/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;


(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.DropdownPopulation = Tc.Module.extend({

        on: function (callback) {
            var $ctx = this.$ctx,
            	hashParams = window.location.hash.slice(1),
            	getParams = window.location.search.slice(1),
            	requestUrl = $ctx.data("ws-url").toLowerCase(),
            	useWebService = $ctx.data("use-ws"),
            	valueField = $ctx.data("ws-value-field"),
            	labelField = $ctx.data("ws-label-field"),
            	id = $ctx.data("ws-id");


            if( useWebService ) {
                debug.log("Tc.Module.DropdownPopulation > Use web service to populate dropdown");
                debug.log("Tc.Module.DropdownPopulation > Web service URL:", requestUrl);
                debug.log("Tc.Module.DropdownPopulation > Value field ", valueField);
                debug.log("Tc.Module.DropdownPopulation > Label field ", labelField);

				var paramMap = this.getParamMap(getParams, hashParams);

				$.each(paramMap, function(key, value) {
					debug.log("Tc.Module.DropdownPopulation > key, value ", key, value);
					requestUrl = requestUrl.replace("$"+key.toLowerCase(), value);
				});
                this.callWebService(requestUrl, valueField, labelField, id);
            }

            callback();
        },

		getParamMap: function(getParams, hashParams) {
			var params = getParams.split('&'),
			    hParam = hashParams.split('&'),
                paramMap = {};
                $.each(params, function(index, item) {
                    var parts = item.split('=');
                    if( parts.length == 2 ) {
                        paramMap[parts[0]] = parts[1];
                    }
                });
                $.each(hParam, function(index, item) {
                    var parts = item.split('=');
                    if( parts.length == 2 ) {
                        paramMap[parts[0]] = parts[1];
                    }
                });
            return paramMap;
		},

        callWebService: function(requestUrl, valueField, labelField, id) {

			$.ajax({
				dataType:"json",
			    url: requestUrl,
				success: function (data, status) {
	                debug.log('Tc.Module.DropdownPopulation > callWebService ', status);

	                if (status === 'success') {
	                    debug.log('Tc.Module.DropdownPopulation > initDropdown - receved data', data);
                        var selectDom = $("#" + id),
                                optionsValues = "";

                        if( Object.prototype.toString.call(data) === '[object Array]' ) {
	                        $.each(data, function(index,item) {
	                            if( item.hasOwnProperty(valueField) && item[valueField].length > 0 && item.hasOwnProperty(labelField) && item[labelField].length > 0 ) {
	                                optionsValues += '<option value="' + item[valueField] + '">' + item[labelField] + '</option>';
	                            }
	                        })
	                        debug.log('Tc.Module.DropdownPopulation > initDropdown', optionsValues);
	                        selectDom.html(optionsValues);
	                        selectDom.resetSS();
                        };
	                } else {
	                    debug.log('Tc.Module.DropdownPopulation > could not update', data);
	                }
	            }
			});
        }
    });
}(Tc.$, window));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.DropdownPopulation.js
// module id = 275
// module chunks = 0